const testIds = {
  images: 'images',
};

export default testIds;
